import { MutableEntityType } from 'app/agriculture/mutations/types/entityConfig';
import { useSelectedFarm } from 'app/agriculture/hooks/useSelectedFarm/useSelectedFarm';
import { useCallback } from 'react';

export type EntityQueryKey<T extends MutableEntityType> = [
    entityType: T,
    { farm_id: number; timeZone: string },
];

export function useEntityQueryKey<T extends MutableEntityType>(): (
    entityType: T,
) => EntityQueryKey<T> {
    const farm = useSelectedFarm();

    return useCallback(
        (entityType: T) => {
            return [
                entityType,
                {
                    farm_id: farm.id,
                    timeZone: farm.timeZone,
                },
            ];
        },
        [farm.id, farm.timeZone],
    );
}
